var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLoadingLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 84.2 84.2",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      margin: "initial",
      display: "block",
      shapeRendering: "auto",
      background: "rgba(255, 255, 255, 0)"
    },
    preserveAspectRatio: "xMidYMid",
    width: 50,
    height: 50,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fffef6;\r\n        stroke: #fff;\r\n      }\r\n      .cls-1,\r\n      .cls-2,\r\n      .cls-3,\r\n      .cls-4,\r\n      .cls-5 {\r\n        stroke-miterlimit: 10;\r\n        stroke-width: 2px;\r\n      }\r\n      .cls-2 {\r\n        fill: none;\r\n      }\r\n      .cls-2,\r\n      .cls-5 {\r\n        stroke: #9c9;\r\n      }\r\n      .cls-3 {\r\n        fill: #e1edf8;\r\n      }\r\n      .cls-3,\r\n      .cls-4 {\r\n        stroke: #9fc9eb;\r\n      }\r\n      .cls-4 {\r\n        fill: #e7f0fa;\r\n      }\r\n      .cls-5 {\r\n        fill: #bbdfbf;\r\n      }\r\n\r\n      @keyframes flip {\r\n        0% {\r\n          transform: rotateY(0deg);\r\n        }\r\n        20% {\r\n          transform: rotateY(90deg);\r\n        }\r\n        40% {\r\n          transform: rotateY(0deg);\r\n        }\r\n      }\r\n\r\n      .animate {\r\n        animation: flip 2s linear infinite;\r\n        transform-style: preserve-3d;\r\n      }\r\n    "))), /*#__PURE__*/React.createElement("g", {
    className: "ldl-scale",
    style: {
      transformOrigin: "50% 50%",
      transform: "rotate(0deg) scale(1, 1) scaleX(-1)"
    }
  }, /*#__PURE__*/React.createElement("g", {
    className: "ldl-ani animate",
    style: {
      opacity: 1,
      transformOrigin: "42.1px 42.1px"
    }
  }, /*#__PURE__*/React.createElement("circle", {
    r: 41.1,
    cy: 42.1,
    cx: 42.1,
    className: "cls-1",
    style: {
      fill: "rgb(255, 254, 246)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.06,45.06a22,22,0,0,1,8.21,7c5.3,7.21,5.95,15.92,6.07,18.6",
    className: "cls-2",
    style: {
      stroke: "rgb(153, 204, 153)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57,43.57a36,36,0,0,0-8.5,9.59A48.9,48.9,0,0,0,42,75.74s-.24-6.22,1-30.48",
    className: "cls-2",
    style: {
      stroke: "rgb(153, 204, 153)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.11,30.26a6.85,6.85,0,0,0-5.25-3.12,6.86,6.86,0,0,0-5.33-3,6.86,6.86,0,0,0-5.33,3A6.85,6.85,0,0,0,11,30.26a6.85,6.85,0,0,0-.08,6.11A6.84,6.84,0,0,0,11,42.48,6.8,6.8,0,0,0,16.2,45.6a6.84,6.84,0,0,0,5.33,3,6.84,6.84,0,0,0,5.33-3,6.82,6.82,0,0,0,5.25-3.11,6.87,6.87,0,0,0,.08-6.12A6.85,6.85,0,0,0,32.11,30.26Z",
    className: "cls-3",
    style: {
      fill: "rgb(225, 237, 248)",
      stroke: "rgb(159, 201, 235)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.07,33.14a6,6,0,0,0-4.6-2.73,5.46,5.46,0,0,0-9.33,0,6,6,0,0,0-4.6,2.73,6,6,0,0,0-.06,5.34,6,6,0,0,0,.06,5.35,6,6,0,0,0,4.6,2.73,5.46,5.46,0,0,0,9.33,0,6,6,0,0,0,4.6-2.73,6,6,0,0,0,.06-5.35A6,6,0,0,0,74.07,33.14Z",
    className: "cls-3",
    style: {
      fill: "rgb(225, 237, 248)",
      stroke: "rgb(159, 201, 235)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.94,18.62c-1.53-2.65-4.4-4.21-7.88-4.68-2.15-2.78-4.94-4.48-8-4.48s-5.84,1.7-8,4.48c-3.48.47-6.35,2-7.88,4.68s-1.45,5.92-.11,9.17c-1.34,3.25-1.42,6.52.11,9.16s4.4,4.22,7.88,4.68c2.14,2.79,4.93,4.49,8,4.49s5.85-1.7,8-4.49c3.48-.46,6.35-2,7.88-4.68s1.45-5.91.11-9.16C60.39,24.54,60.47,21.27,58.94,18.62Z",
    className: "cls-4",
    style: {
      fill: "rgb(231, 240, 250)",
      stroke: "rgb(159, 201, 235)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.11,22.61A4.61,4.61,0,0,0,45.8,19.7",
    className: "cls-4",
    style: {
      fill: "rgb(231, 240, 250)",
      stroke: "rgb(159, 201, 235)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54,32.27a3.62,3.62,0,0,0-.74-3.49c-.88-1.05-2.74-.83-4.33-1.11-1.17-1.12-2.1-2.74-3.47-2.82a3.63,3.63,0,0,0-3.25,1.48",
    className: "cls-4",
    style: {
      fill: "rgb(231, 240, 250)",
      stroke: "rgb(159, 201, 235)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33,32.26a3.63,3.63,0,0,0,1.39,3.28c1.06.87,2.84.31,4.46.28,1.36.87,2.58,2.29,3.94,2.12a3.66,3.66,0,0,0,2.91-2.07",
    className: "cls-4",
    style: {
      fill: "rgb(231, 240, 250)",
      stroke: "rgb(159, 201, 235)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.54,16.93a3.64,3.64,0,0,0-3.4-1.1c-1.35.25-2.08,2-3.11,3.21-1.56.46-3.42.46-4.18,1.61a3.61,3.61,0,0,0-.33,3.55",
    className: "cls-4",
    style: {
      fill: "rgb(231, 240, 250)",
      stroke: "rgb(159, 201, 235)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.77,72.12s2-5.6,4.6-7.64c4.92-3.92,13.81-2.85,13.81-2.85S60.44,68.58,56.09,71,44.77,72.12,44.77,72.12Z",
    className: "cls-5",
    style: {
      fill: "rgb(187, 223, 191)",
      stroke: "rgb(153, 204, 153)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37,72.12s-1.78-5.6-4-7.64c-4.28-3.92-12-2.85-12-2.85s2.38,6.95,6.16,9.39S37,72.12,37,72.12Z",
    className: "cls-5",
    style: {
      fill: "rgb(187, 223, 191)",
      stroke: "rgb(153, 204, 153)"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadingLogo);
export default __webpack_public_path__ + "static/media/Loading_logo.d7016a172fbfb917b8d75e17f6c28766.svg";
export { ForwardRef as ReactComponent };